"use client";
export const InitialScreen = () => {
  return (
    <div className="py-10 flex flex-col items-center justify-end">
      <h1 className="text-3xl font-semibold mb-4">Mingdu</h1>
      <p className="">
        MingDu will chat with you, keep track of words you&apos;ve seen, correct
        your grammar, and naturally help you build your vocabulary.
      </p>
      <p className="mt-2">
        Mention something you want to talk about, or simply hit enter to start a
        new conversation.
      </p>
    </div>
  );
};
